<template>
  <div class="checkout-builder-header">
    <div class="d-flex align-items-center">
      <div class="return-button">
        <bp-button
          color="neutral"
          variant="glyph"
          icon="fa fa-angle-left"
          label="Sair"
          @click="
            $router.push({
              name: 'product-details',
              params: { id: $route.params.id }
            })
          "
        />
      </div>

      <div class="flex-fill d-flex justify-content-end gap-3">
        <bp-button
          icon="fa-regular fa-desktop"
          :variant="device == 'desktop' ? 'outlined-1' : 'glyph'"
          @click="setDevice('desktop')"
        />
        <bp-button
          icon="fa-regular fa-mobile"
          :variant="device == 'mobile' ? 'outlined-1' : 'glyph'"
          @click="setDevice('mobile')"
        />
        <bp-button
          color="neutral"
          variant="outlined"
          :label="editing ? 'Visualizar' : 'Editar'"
          @click="toggleEditing"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("checkoutBuilder", ["device", "editing"])
  },
  methods: {
    setDevice(device) {
      this.$store.commit("checkoutBuilder/setDevice", device);
    },
    toggleEditing() {
      this.$store.commit("checkoutBuilder/setEditing", !this.editing);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-header {
  padding: 16px;
  min-height: 72px;
  position: relative;

  border-bottom: 1px solid #d7d7d7;
  background: rgba(255, 255, 255, 0.64);

  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);

  @media screen and (min-width: 992px) {
    .return-button {
      display: flex;
      width: calc(343px - 16px);
    }
  }
}
</style>
